import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import MuscleApp from "./app/MuscleApp";
import "./app/globals.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MuscleApp />
  </StrictMode>,
);
